import { FileWarning, ShieldAlert } from "lucide-react";

import { Badge } from "../ui/badge";

// "Exige receita" e "Controlado": o produto aparece, com aviso (decisão do
// plano da Farmax). Aceita o produto do painel (`requiresPrescription`) e o da
// vitrine (`exigeReceita`), que vêm com nomes diferentes da API.
const SelosDeFarmacia = ({ produto, className = "" }) => {
	const receita = produto?.requiresPrescription || produto?.exigeReceita;
	const controlado = produto?.isControlled || produto?.controlado;

	if (!receita && !controlado) return null;

	return (
		<span className={`inline-flex flex-wrap gap-1 ${className}`}>
			{controlado ? (
				<Badge variant="perigo" className="gap-1 font-normal">
					<ShieldAlert className="h-3 w-3" aria-hidden />
					Controlado
				</Badge>
			) : (
				<Badge variant="aviso" className="gap-1 font-normal">
					<FileWarning className="h-3 w-3" aria-hidden />
					Exige receita
				</Badge>
			)}
		</span>
	);
};

export default SelosDeFarmacia;
